import { call } from 'redux-saga/effects';
import { PaymentResource } from '../../core/resources/payment.resource';
import {
  ESpecialOfferType,
  IApiEligibleCategories,
} from '../../models/payment/eligible-categories.types';
import { IApiEligibleProducts } from '../../models/payment/eligible-products.types';
import {
  getActiveSpecialOffer,
  getPassCategory,
} from '../../models/payment/payment.serializer';
import {
  IApiPaymentHistory,
  IPaymentUrl,
  IPaymentUrlSpecialOffer,
  IPaymentWebViewParams,
} from './payment.types';

const BLACKLISTED_CATEGORIES = ['COMMAND'];

export function* getEligibleCategories() {
  const eligibleCategories: IApiEligibleCategories = yield call(
    PaymentResource.getEligibleCategories
  );

  return eligibleCategories.attributes.categories.filter(
    ({ id }) => !BLACKLISTED_CATEGORIES.includes(id)
  );
}

export function* getCurrentSpecialOffer() {
  const eligibleCategories: IApiEligibleCategories = yield call(
    PaymentResource.getEligibleCategories
  );

  const categoryPass = getPassCategory(eligibleCategories);

  if (!categoryPass) return;

  const currentDate = new Date();

  return getActiveSpecialOffer(categoryPass, currentDate);
}

export function* getEligibleProducts(category: string) {
  const eligibleProducts: IApiEligibleProducts = yield call(
    PaymentResource.getEligibleProducts,
    category
  );

  return eligibleProducts.attributes.products;
}

export function* getPaymentWebviewUrl({
  actionCode,
  returnUrlOk,
  returnUrlKo,
}: IPaymentWebViewParams) {
  const urlResponse: IPaymentUrl = yield call(PaymentResource.getWebviewUrl, {
    actionCode,
    returnUrlOk,
    returnUrlKo,
  });

  return urlResponse.attributes;
}

export function* getPaymentWebviewUrlWithSpecialOffer(
  specialOfferType: ESpecialOfferType,
  { actionCode, returnUrlOk, returnUrlKo }: IPaymentWebViewParams
) {
  const urlResponse: IPaymentUrlSpecialOffer = yield call(
    PaymentResource.getWebviewUrlWithSpecialOffer,
    specialOfferType,
    { actionCode, returnUrlOk, returnUrlKo }
  );

  return urlResponse.attributes;
}

export function* getPaymentHistory() {
  const history: IApiPaymentHistory = yield call(PaymentResource.getHistory);

  return history.attributes;
}
